import { NgModule } from "@angular/core";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { NgxsStoragePluginModule, NgxsStoragePluginOptions, StorageOption } from "@ngxs/storage-plugin";
import { NgxsModule, NgxsModuleOptions } from "@ngxs/store";
import { environment } from "src/environments/environment";

/**
 * The global NGXS configuration options
 */
export const NGXS_MODULE_OPTIONS: NgxsModuleOptions = {
  developmentMode: !environment.production,
  selectorOptions: {
    // These Selector Settings are recommended in preparation for NGXS v4
    // (See above for their effects)
    suppressErrors: false,
    injectContainerState: true,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
};

/**
 * The global NGXS storage configuration options.
 *
 * **Note**
 *
 * The storage plugin does not support for feature lazy-loaded modules so they have to be declared in the root module
 * Source: https://github.com/ngxs/store/issues/850
 */
export const NGXS_STORAGE_PLUGIN_OPTIONS: NgxsStoragePluginOptions = {
  // A list of states that should be persisted in storage.
  // Make sure that data, specifically customer data, is not persistent in session storage unless required.
  key: [
    "flowsSubmitContractSection",
    "flowsSubmitRenewalSection",
    "flowsChangeContractSwedenCheckout",
    "energySourceSubmitter",
    "flowsAcquisitionBusinessSwedenCheckout",
    "flowsAcquisitionPrivateSwedenCheckout",
    "flowsMoveBusinessSwedenCheckout",
    "flowsMovePrivateSwedenCheckout",
    "myContactNotificationDialog",
    "flowsFiRenewalCheckout",
  ],
  storage: StorageOption.SessionStorage,
};

@NgModule({
  imports: [
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsModule.forRoot([], NGXS_MODULE_OPTIONS),
    NgxsStoragePluginModule.forRoot(NGXS_STORAGE_PLUGIN_OPTIONS),
  ],
})
export class NgxsConfigModule {}
